//frontend/src/pages/history/historystages/HOST.jsx
import React from 'react';
import SubjectsPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history/Contemporary_Period_-_Climate_Change_and_Environmental_Movements.png';

const subTopics = [
  { name: 'Industrial Innovations', route: '/History-Industrial-Innovations', key: 'Industrial Innovations' },
  { name: 'Space Race', route: '/History-Space-Race', key: 'Space Race' },
  { name: 'Computers and the Internet', route: '/History-Computers-Internet', key: 'Development of Computers and the Internet' },
  { name: 'Medical Breakthroughs', route: '/History-Medical-Breakthroughs', key: 'Medical Breakthroughs (e.g., Vaccines, DNA)' },
  { name: 'AI & Robotics', route: '/History-AI-Robotics', key: 'Artificial Intelligence & Robotics' }
];


function HistoryPageHOST() {
  return (
    <SubjectsPage
      title="Science and Tech"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageHOST;
